export default {
  setPanelToCopy({ commit }, id = null) {
    commit('setPanelToCopy', id)
  },
  pastePanel({ dispatch }, { id = '', parentId = '' } = {}) {
    dispatch('duplicate', { id, parentId })
    dispatch('setPanelToCopy')
  },
  duplicate({ dispatch, getters }, { id = null, parentId = '' } = {}) {
    const root = getters.objectById(id)
    const descendants = getters.descendants(id)

    dispatch('batchAdd', { parentId, elements: [root, ...descendants] })
  },
}
